import { UserType } from 'modules/User';
import { IconWidgetData } from 'widgets/IconWidget/IconWidget.types';
import { NewWidget } from 'widgets/Widget.types';

export enum ElementTypes {
  TextBlocks = 'Text Blocks',
  Lists = 'Lists',
  Signatures = 'Signatures',
  ImageFrames = 'Image Frames',
  ImageGrids = 'Image Grids',
  QRCode = 'QR Code',
  VideoEmbed = 'Video Embed',
}

export interface IconDataOverride extends Partial<IconWidgetData> {
  iconId: string;
  viewBox: string;
  iconConfig: Partial<IconWidgetData>;
  topPxOverride?: number | undefined;
  leftPxOverride?: number | undefined;
  mono?: boolean | undefined;
}

export type Thumbnail = {
  src: string;
  altText: string;
};

export interface ElementWidget extends Partial<NewWidget> {
  iconWidgetData?: IconDataOverride;
}

export interface ElementsConfigData {
  id: string;
  type: ElementTypes;
  elementWidgetsMap: Partial<ElementWidget>[];
  thumbnail: Thumbnail;
  permission?: UserType;
  fontsToLoad?: string[];
}
